export enum UserProfile {
  Admin = '1d9a359a-910e-45a0-9bfd-29eedf814b12',
  Employee = 'ec2f67da-d7b0-4486-85a7-b8f297c5dc3c',
  Owner = 'a90baf90-b2b4-4ed9-a268-4be4f6addb1c',
  Master = '5f2a7f61-c784-4b1a-93f5-ec989686ba58',
}